// extracted by mini-css-extract-plugin
module.exports = {"high-risk":"HighRisk_high-risk__Bs7GJ"};